module.exports = __webpack_public_path__ + "static/Blog-carousel-7b6f78fb08950dd73bde5347bb207cd2.png";